export const colours = {
  background:   '#0D0D0F',
  surface:      '#1A1A20',
  surfaceRaise: '#24242C',

  tonic:       '#FF6B6B',
  subdominant: '#FFD93D',
  dominant:    '#6BCB77',
  leading:     '#4D96FF',

  keys: [
    '#FF6B6B', '#FF8E53', '#FFD93D', '#C8F560',
    '#6BCB77', '#4ECDC4', '#45B7D1', '#4D96FF',
    '#9B59FF', '#E040FB', '#FF4081', '#FF6B6B',
  ],

  textPrimary:   '#FFFFFF',
  textSecondary: '#A0A0B0',
  textMuted:     '#606070',

  intervalRoot:    '#FF6B6B',
  intervalThird:   '#FFD93D',
  intervalFifth:   '#6BCB77',
  intervalSeventh: '#4D96FF',
  intervalOther:   '#9B59FF',

  border:  '#2E2E3A',
  accent:  '#FF6B6B',

  arpeggio:           '#E6C46E',
  arpeggioOutOfScale: '#22D3EE',
};
